/**
 * @typedef {Object<string, string[]>} TableColumnSpec
 * @typedef {{ sheets:string[], namedRanges:string[], tables:TableColumnSpec }} MiniBaseline
 */

/** ------------------------------------------------
 * 1) Baseline – edit this to match your template
 * ------------------------------------------------ */
const BASELINE = /** @type {MiniBaseline} */ ({
  sheets: [
    "A Admin",
    "A Lists",
    "A Log",
    "Security",
    "Version",
    "Report design (portrait)",
    "Report design (landscape)",
    "Uploads",
    "Validation",
    "Post Manual Journal",
    "Post Rounding Journal",
    "Set-up",
    "Detail",
  ],
  namedRanges: [
    // Set-up
    "OrgNameLong",
    "OrgNameShort",
    "Country",
    "ReportingType",
    "DisplayUnits",
    "PeriodStart",
    "PeriodEnd",
    "CurrentYear",
    "PriorYear",
    // Detail
    "Principal",
    "CertifierName",
    "CertifierTitle",
    // Validation
    "Validation_Step1",
    "Validation_Item1",
    "Validation_Item2",
    "Validation_Item3",
    "Validation_Step2",
    "Validation_Item4",
    "Validation_Item5",
    "Validation_Item6",
    "Validation_Item7",
    "Validation_Step3",
    "Validation_Item8",
    "Validation_Item9",
    "Climate_Validation",
    "Finance_Validation",
    "Land_Validation",
    "Resource_Validation",
    "Pollution_Validation",
    "Invasive_Validation",

  ],
  tables: {
    Security: ["Name", "Contributor", "Approver", "Publisher", "Administrator"],
    uploadRegister: [
      "Document ID",
      "Document Name",
      "File Binary",
      "Upload Date",
      "Uploaded By",
      "Disclosure Type",
      "Table",
      "Entity",
      "Scenario",
      "Description",
      "Download",
      "Approved",
      "Delete",
    ],
  },
});

/** ------------------------------------------------
 * 2) Public entry – call at Office.onReady
 *    Returns TRUE if everything is OK.
 * ------------------------------------------------ */
export async function runMiniIntegrityCheck() {
  /** @type {string[]} */
  const errs = [];

  await Excel.run(async (ctx) => {
    /* --- Load everything we need in one go -------- */
    const ws = ctx.workbook.worksheets;
    const tbl = ctx.workbook.tables;
    const nms = ctx.workbook.names;

    ws.load("items/name");
    tbl.load("items/name,items/columns/items/name");
    nms.load("items/name");
    await ctx.sync();

    /* --- 1. Worksheets --------------------------- */
    const sheetSet = new Set(ws.items.map((w) => w.name));
    BASELINE.sheets.forEach((s) => {
      if (!sheetSet.has(s)) errs.push(`Missing sheet '${s}'`);
    });

    /* --- 2. Named Ranges ------------------------- */
    const nmSet = new Set(nms.items.map((n) => n.name));
    BASELINE.namedRanges.forEach((nm) => {
      if (!nmSet.has(nm)) errs.push(`Missing named range '${nm}'`);
    });

    /* --- 3 & 4. Tables + Columns ----------------- */
    const tblMap = new Map(tbl.items.map((t) => [t.name, t]));
    for (const [tblName, colsRequired] of Object.entries(BASELINE.tables)) {
      const t = tblMap.get(tblName);
      if (!t) {
        errs.push(`Missing table '${tblName}'`);
        continue;
      }

      const colSet = new Set(t.columns.items.map((c) => c.name));
      colsRequired.forEach((cn) => {
        if (!colSet.has(cn)) errs.push(`Table '${tblName}' missing column '${cn}'`);
      });
    }
  });

  /* --- Report ------------------------------------ */
  if (errs.length) {
    console.error("Integrity check failed:", errs);
    //alert("Template issues:\n• " + errs.join("\n• "));
    return false;
  }
  console.log("Integrity check passed ✓");
  return true;
}
